import { RetailerNetworkLocationFragment } from '@occc/graphql';

// All stores of the group are fetched in a single request so the map can render every pin;
// the table uses server-side pagination via a separate query.
export const ALL_GROUP_LOCATIONS_PAGE_SIZE = 500;
export const TABLE_PAGE_SIZE = 8;

export const getLocationSiteId = (location: RetailerNetworkLocationFragment): string =>
  location.location.siteSystemConfiguration?.[0]?.identifier || '';

export const getLocationSiteName = (location: RetailerNetworkLocationFragment): string =>
  location.location.name || '';

export const getLocationPhoneNumber = (location: RetailerNetworkLocationFragment): string =>
  location.location.phoneNumbers?.[0]?.phoneNumber || '';

export const getLocationStreet = (location: RetailerNetworkLocationFragment): string =>
  location.location.address?.street1 || '';

export const getLocationCityStateZip = (location: RetailerNetworkLocationFragment): string => {
  const city = location.location.address?.city || '';
  const state = location.location.address?.state || '';
  const zip = location.location.address?.zipCode || '';
  const cityState = [city, state].filter(Boolean).join(', ');
  return [cityState, zip].filter(Boolean).join(' ');
};

// Design renders the address on a single line: "211 North 13th St. Philadelphia, PA 19403".
export const getLocationAddress = (location: RetailerNetworkLocationFragment): string =>
  [getLocationStreet(location), getLocationCityStateZip(location)].filter(Boolean).join(' ');
